export function PassportAndMapPage() {
   return (
      <div>
         <h1>Passport and Map</h1>
         <p>Passport and map page content</p>
      </div>
   );
}
